<div class="tw-bg-[#F8F9FB] tw-min-h-screen">
    <app-dashboard-wrapper>
        <div class="tw-flex tw-items-center tw-justify-between">
            <h2 class="!tw-text-xl !tw-font-semibold !tw-mb-3">
                {{ "NOTIFICATIONS.TITLE" | translate }}
            </h2>
            <button
                (click)="handleNotification()"
                class="tw-text-[#4B6EEC] tw-underline tw-cursor-pointer !tw-mb-3"
            >
                {{ "NOTIFICATIONS.MARK_ALL" | translate }}
            </button>
        </div>
        <div
            class="tw-w-full tw-bg-white tw-rounded-xl tw-min-h-[255px] tw-px-3 md:tw-px-8 tw-py-8 tw-relative"
        >
            <div class="tw-flex tw-flex-col tw-gap-5">
                <div
                    *ngFor="let item of notifications"
                    class=""
                    (click)="handleNotification(item)"
                >
                    <div
                        class="tw-flex tw-items-start md:tw-items-center tw-gap-3 md:tw-gap-6 tw-cursor-pointer"
                    >
                        <div
                            class="tw-h-[30px] tw-w-[30px] md:tw-h-[48px] md:tw-w-[48px] tw-rounded-full tw-bg-[#4B6EEC1A] tw-flex tw-justify-center tw-items-center tw-relative"
                        >
                            <span
                                *ngIf="item.isRead === 'N'"
                                class="tw-min-w-[8px] tw-min-h-[8px] tw-rounded-full tw-bg-[#FF1212] tw-absolute tw-top-[4px] tw-right-[6px]"
                            ></span>
                            <svg
                                class="tw-block md:tw-hidden"
                                width="14"
                                height="18"
                                viewBox="0 0 14 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clip-path="url(#clip0_11063_27323)">
                                    <path
                                        d="M8.57249 0L8.57106 3.59855C8.57583 4.24861 9.31816 5.01982 10.0185 5.01982H13.9286V15.8459C13.9286 16.4141 13.0966 17.1361 12.4816 17.1339C8.71657 17.1022 4.93482 17.2001 1.17932 17.0843C0.541476 16.9189 0.0505695 16.3716 0 15.7466L0.00238536 1.356C0.0610651 0.837829 0.394538 0.411314 0.870178 0.161396L1.3587 0H8.57202H8.57249ZM10.56 7.20649C10.4731 7.12512 10.2871 7.06387 10.163 7.05985L3.73356 7.06119C3.05135 7.13093 3.05135 7.99559 3.73356 8.06533H10.1974C10.6501 8.04253 10.8892 7.51453 10.56 7.20649ZM10.56 9.21433C10.4731 9.13296 10.2871 9.07171 10.163 9.06769L3.73356 9.06903C3.05135 9.13877 3.05135 10.0034 3.73356 10.0732H10.1974C10.6501 10.0504 10.8892 9.52237 10.56 9.21433ZM10.56 11.2226C10.4731 11.1412 10.2871 11.08 10.163 11.076L3.73356 11.0773C3.05135 11.1471 3.05135 12.0117 3.73356 12.0815H10.1974C10.6501 12.0587 10.8892 11.5307 10.56 11.2226ZM8.41744 13.2305C8.32537 13.1442 8.14933 13.0945 8.02052 13.0838C6.65896 12.9689 5.11468 13.1728 3.73356 13.0852C3.06566 13.1536 3.04705 13.9829 3.70112 14.0862L8.05487 14.0893C8.50761 14.0665 8.74662 13.5385 8.41744 13.2305Z"
                                        fill="#4B6EEC"
                                    />
                                    <path
                                        d="M13.6085 4.01513H10.0553C9.93125 4.01513 9.64453 3.74688 9.64453 3.63019V0.300781L13.6085 4.01557V4.01513Z"
                                        fill="#4B6EEC"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_11063_27323">
                                        <rect
                                            width="13.9286"
                                            height="17.1429"
                                            fill="white"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>

                            <svg
                                class="tw-hidden md:tw-block"
                                width="23"
                                height="28"
                                viewBox="0 0 23 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clip-path="url(#clip0_8785_13836)">
                                    <path
                                        d="M13.714 0L13.7117 5.75768C13.7194 6.79777 14.9071 8.03171 16.0276 8.03171H22.2838V25.3534C22.2838 26.2626 20.9525 27.4178 19.9686 27.4143C13.9446 27.3635 7.89377 27.5201 1.88496 27.3349C0.864408 27.0702 0.0789582 26.1946 -0.00195312 25.1946L0.00186345 2.16959C0.0957511 1.34053 0.629308 0.658103 1.39033 0.258234L2.17197 0H13.7133H13.714ZM16.894 11.5304C16.7551 11.4002 16.4574 11.3022 16.2589 11.2958L5.97174 11.2979C4.8802 11.4095 4.8802 12.7929 5.97174 12.9045H16.3139C17.0383 12.868 17.4207 12.0232 16.894 11.5304ZM16.894 14.7429C16.7551 14.6127 16.4574 14.5147 16.2589 14.5083L5.97174 14.5104C4.8802 14.622 4.8802 16.0055 5.97174 16.1171H16.3139C17.0383 16.0806 17.4207 15.2358 16.894 14.7429ZM16.894 17.9562C16.7551 17.826 16.4574 17.728 16.2589 17.7216L5.97174 17.7237C4.8802 17.8353 4.8802 19.2187 5.97174 19.3303H16.3139C17.0383 19.2938 17.4207 18.449 16.894 17.9562ZM13.466 21.1687C13.3186 21.0307 13.037 20.9513 12.8309 20.9341C10.6524 20.7503 8.18154 21.0764 5.97174 20.9362C4.9031 21.0457 4.87333 22.3726 5.91984 22.5379L12.8858 22.5429C13.6102 22.5064 13.9926 21.6616 13.466 21.1687Z"
                                        fill="#4B6EEC"
                                    />
                                    <path
                                        d="M21.7713 6.42537H16.0862C15.8877 6.42537 15.429 5.99618 15.429 5.80948V0.482422L21.7713 6.42609V6.42537Z"
                                        fill="#4B6EEC"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_8785_13836">
                                        <rect
                                            width="22.2857"
                                            height="27.4286"
                                            fill="white"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div
                            class="tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center hover:tw-text-[#4B6EEC] tw-justify-between tw-w-full"
                        >
                            <p class="!tw-font-semibold !tw-mb-2">
                                {{
                                    selectedLanguage == "en"
                                        ? item?.message
                                        : item?.bmMessage
                                }}
                            </p>
                            <div
                                class="tw-flex tw-items-center tw-gap-4 tw-text-xs md:tw-text-sm tw-text-[#00000066] tw-mt-1 md:tw-mt-0 tw-mb-4 md:!tw-mb-2"
                            >
                                <span>{{
                                    item?.dateTime | date : "dd MMMM, yyyy"
                                }}</span>
                                <span>{{
                                    item?.dateTime | date : "hh:mm a"
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <hr
                        class="tw-border-b-2 tw-border-[#B5B5B580] tw-mt-3 tw-w-[calc(100%-40px)] md:tw-w-[calc(100%-65px)] tw-ml-auto"
                    />
                </div>
            </div>
        </div>
    </app-dashboard-wrapper>
</div>
<app-loader [showLoader]="isLoading"></app-loader>
